<template>
  <div class="app-detail-container">
    <div class="breadcrumbs mb-40">
      <div class="breadcrumb">
        <div class="btn-back">
          <div class="container">
            <el-link
              class="font-16 font-w-bold"
              @click="handleBack">
              API Test Tool Webhook - {{ title }}
            </el-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-32">
      <el-row :gutter="60">
        <el-col :span="12">
          <el-form
            :model="form"
            label-position="top"
            style="max-width: 100%"
          >
            <div class="font-w-semi-bold font-18 mb-24">
              Request Parameters
            </div>
            <el-form-item label="App Pairing Store">
              <el-select
                v-model="form.selectedStore"
                placeholder="Select pairing store"
                style="width:100%;"
                @change="changeStore"
              >
                <el-option
                  v-for="item in form.storeData"
                  :key="item.id"
                  :label="item.store_url_id"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="URL" prop="endpoint">
              <el-input v-model="form.endpoint" disabled />
            </el-form-item>
            <el-form-item
              v-for="(item, index) in form.header_request"
              :key="index"
              :prop="'header_request.' + index + '.value'"
              class="mb-16"
              style="width: 100%;"
            >
              <el-row>
                <el-col :span="12">
                  <span slots="label" class="font-12 mb-2">
                    Header
                  </span>
                  <el-input v-model="item.header" disabled style="width: 94%;" />
                </el-col>
                <el-col :span="12">
                  <span slots="label" class="font-12 mb-2">
                    Value
                  </span>
                  <el-input v-model="item.value" disabled style="width: 94%;" />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="Request body">
              <el-input
                v-model="form.requestBody"
                :rows="10"
                placeholder="Please input"
                type="textarea"
              />
            </el-form-item>
          </el-form>
          <el-button
            :loading="loading"
            :disabled="disableRequest"
            type="success"
            class="btn-full-block"
            @click="handleSendRequest"
          >
            Send Request
          </el-button>
        </el-col>
        <el-col :span="12">
          <code-editor
            title="JSON"
            :data="dataResponse"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script setup>
import { listPairingStore, detailPairingStore, sendCollectionWebhook } from '@/api/endpoints/catalog/authOlsera.js'
import { ref, reactive, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import CodeEditor from '../components/_codeEditor.vue'

const store = useStore()
const route = useRoute()
const router = useRouter()
const loading = ref(false)
const title = ref(route.query.name)
const form = reactive({
  selectedStore: '',
  endpoint: '',
  storeData: [],
  header_request: [],
  requestBody: {},
  method: 'POST'
})
const dataResponse = ref(null)
const paramAppList = reactive({
  page: 1,
  per_page: 9,
  total: 0
})

const disableRequest = computed(() => {
  if (
    form.selectedStore &&
    form.endpoint
  ) {
    return false
  } else {
    return true
  }
})

onMounted(() => {
  getPairingStore()
  getDataWebhook()
})

const getDataWebhook = () => {
  const requestData = store.getters['app/dataWebhook']
  form.requestBody = JSON.stringify(requestData, null, 4)
}
const changeStore = () => {
  const data = {
    id: form.selectedStore
  }
  getDataDetailPairing(data)
}
const getPairingStore = () => {
  listPairingStore(paramAppList).then(res => {
    form.storeData = res.data.data
  }).catch(err => {
    console.log('err', err)
  })
}
const getDataDetailPairing = (data) => {
  detailPairingStore(data).then(res => {
    form.endpoint = res.data.data.webhook
    form.header_request = res.data.data.header_request
  }).catch(err => {
    console.log('err', err)
  })
}
const handleSendRequest = () => {
  loading.value = true
  sendCollectionWebhook(form).then((response) => {
    dataResponse.value = response.data
    loading.value = false
  }).catch((err) => {
    console.log(err)
    dataResponse.value = err.string
    loading.value = false
  })
}
const handleBack = () => {
  router.go(-1)
}
</script>
